import { ReactComponent as LogOutIcon } from "../../../../assets/icon/logout.svg";
import { LogOutButton, MoodWrapper } from "../../container/accountSettings.styles";
import Icon from "../../../../components/Icon/Icon";
import { useAppDispatch } from "@features/store/store";
import { logOut } from "../../../../Header/store/headerSlice";
import { useNavigate } from "react-router-dom";
import { RouterPaths } from "../../../../router/routerPaths";

const LogOut = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const handleClick = () => {
        dispatch(logOut());
        navigate(`${RouterPaths.LOGIN}`);
    };
    return (
        <MoodWrapper>
            <Icon icon={LogOutIcon} />
            <LogOutButton type="text" onClick={handleClick}>
                {" "}
                Log out{" "}
            </LogOutButton>
        </MoodWrapper>
    );
};
export default LogOut;
